module.exports = __webpack_public_path__ + "img/location10071.efe6860b.png";